import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=f2e8320c&scoped=true&"
import script from "./downloads.vue?vue&type=script&lang=js&"
export * from "./downloads.vue?vue&type=script&lang=js&"
import style0 from "./downloads.vue?vue&type=style&index=0&id=f2e8320c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e8320c",
  null
  
)

export default component.exports